import React, { useState, useEffect } from 'react';
import {
    FaEye, FaEdit, FaCheck, FaTimes, FaSearch,
    FaBuilding, FaUser, FaEnvelope, FaPhone,
    FaCalendarAlt, FaFilePdf, FaDownload,
    FaSpinner, FaChevronDown, FaChevronUp,
    FaUsers, FaClipboardList, FaClock,
    FaCheckCircle, FaTimesCircle, FaSync,
    FaPlus, FaTrash, FaPaperPlane
} from 'react-icons/fa';

const ManagerClients = () => {
    // ==================== STATE MANAGEMENT ====================
    const [clients, setClients] = useState([
        {
            id: 1,
            clientNo: 'CLT-001',
            company: 'Acme Industries',
            contactPerson: 'Rohit Sharma',
            email: 'rohit@acme.in',
            phone: '+91 98200 11122',
            linkedEnquiry: 'ENQ-X1Y2Z',
            pos: 1,
            owner: 'Priya (Exec)',
            onboarded: '2025-04-20',
            status: 'Active',
            source: 'Quotation Accepted',
            fromDate: '2025-04-20',
            toDate: '2026-04-19',
            website: 'https://www.acmeindustries.com',
            agreementDoc: 'agreement_acme.pdf',
            lastRenewalDate: null,
            nextRenewalDate: '2026-04-19',
            poGenerated: false,
            lastPONumber: null,
            renewalSentCount: 0,
            contractValue: '₹12,00,000',
            paymentTerms: 'Net 30',
            assignedManager: 'Aarav (Manager)'
        },
        {
            id: 2,
            clientNo: 'CLT-002',
            company: 'Nimbus Tech',
            contactPerson: 'Anita Desai',
            email: 'anita@nimbus.io',
            phone: '+91 98300 22333',
            linkedEnquiry: 'ENQ-P9Q3R',
            pos: 2,
            owner: 'Karan (Exec)',
            onboarded: '2025-04-18',
            status: 'Active',
            source: 'Quotation Accepted',
            fromDate: '2025-04-18',
            toDate: '2026-04-17',
            website: 'https://www.nimbustech.io',
            agreementDoc: 'agreement_nimbus.pdf',
            lastRenewalDate: null,
            nextRenewalDate: '2026-04-17',
            poGenerated: true,
            lastPONumber: 'PO-2025-001',
            renewalSentCount: 1,
            contractValue: '₹8,50,000',
            paymentTerms: 'Net 45',
            assignedManager: 'Neha (Manager)'
        },
        {
            id: 3,
            clientNo: 'CLT-003',
            company: 'Orbit Logistics',
            contactPerson: 'Vikram Mehta',
            email: 'vikram@orbit.co',
            phone: '+91 98400 33444',
            linkedEnquiry: 'ENQ-R7S8T',
            pos: 3,
            owner: 'Priya (Exec)',
            onboarded: '2025-04-15',
            status: 'Active',
            source: 'Manual Add',
            fromDate: '2025-04-15',
            toDate: '2026-04-14',
            website: 'https://www.orbitlogistics.co',
            agreementDoc: 'agreement_orbit.pdf',
            lastRenewalDate: null,
            nextRenewalDate: '2026-04-14',
            poGenerated: false,
            lastPONumber: null,
            renewalSentCount: 0,
            contractValue: '₹24,00,000',
            paymentTerms: 'Net 60',
            assignedManager: 'Aarav (Manager)'
        },
        {
            id: 4,
            clientNo: 'CLT-004',
            company: 'BluePeak Foods',
            contactPerson: 'Sara Khan',
            email: 'sara@bluepeak.in',
            phone: '+91 98500 44555',
            linkedEnquiry: 'ENQ-U5V6W',
            pos: 4,
            owner: 'Karan (Exec)',
            onboarded: '2025-04-10',
            status: 'Active',
            source: 'Quotation Accepted',
            fromDate: '2025-04-10',
            toDate: '2026-04-09',
            website: 'https://www.bluepeak.in',
            agreementDoc: 'agreement_bluepeak.pdf',
            lastRenewalDate: null,
            nextRenewalDate: '2026-04-09',
            poGenerated: true,
            lastPONumber: 'PO-2025-089',
            renewalSentCount: 0,
            contractValue: '₹5,75,000',
            paymentTerms: 'Net 30',
            assignedManager: 'Neha (Manager)'
        }
    ]);

    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    // Modals visibility
    const [mgrShowViewModal, setMgrShowViewModal] = useState(false);
    const [mgrShowEditModal, setMgrShowEditModal] = useState(false);
    const [mgrShowApproveModal, setMgrShowApproveModal] = useState(false);
    const [mgrSelectedClient, setMgrSelectedClient] = useState(null);

    // Manager approval / remarks
    const [mgrApprovalRemark, setMgrApprovalRemark] = useState('');

    // Edit form state
    const [mgrEditForm, setMgrEditForm] = useState({
        company: '',
        contactPerson: '',
        email: '',
        phone: '',
        contractValue: '',
        paymentTerms: '',
        assignedManager: '',
        status: 'Active',
        website: ''
    });

    // Auto-load from localStorage
    useEffect(() => {
        const savedClients = localStorage.getItem('clientsData');
        if (savedClients) {
            const parsed = JSON.parse(savedClients);
            if (parsed.length > 0) {
                const merged = parsed.map(c => ({
                    ...c,
                    contractValue: c.contractValue || '—',
                    paymentTerms: c.paymentTerms || 'Standard',
                    assignedManager: c.assignedManager || 'Unassigned'
                }));
                setClients(merged);
            }
        }
    }, []);

    // Stats for manager dashboard
    const totalClients = clients.length;
    const activeClients = clients.filter(c => c.status === 'Active').length;
    const poGeneratedCount = clients.filter(c => c.poGenerated).length;
    const renewalsPending = clients.filter(c => {
        if (!c.toDate) return false;
        const daysLeft = Math.ceil((new Date(c.toDate) - new Date()) / (1000 * 60 * 60 * 24));
        return daysLeft <= 30 && daysLeft > 0;
    }).length;

    const mgrManagerOptions = ['Aarav (Manager)', 'Neha (Manager)', 'Priya (Exec)', 'Karan (Exec)', 'Unassigned'];
    const mgrPaymentTermsOptions = ['Net 30', 'Net 45', 'Net 60', 'Advance', 'Standard'];

    // Helper functions
    const mgrFormatDate = (dateStr) => {
        if (!dateStr) return '—';
        const d = new Date(dateStr);
        return d.toLocaleDateString('en-GB');
    };

    const mgrIsRenewalNeeded = (toDate) => {
        if (!toDate) return false;
        const today = new Date();
        const end = new Date(toDate);
        const days = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
        return days <= 30 && days > 0;
    };

    const mgrHandleView = (client) => {
        setMgrSelectedClient(client);
        setMgrShowViewModal(true);
    };

    const mgrHandleEdit = (client) => {
        setMgrSelectedClient(client);
        setMgrEditForm({
            company: client.company,
            contactPerson: client.contactPerson,
            email: client.email,
            phone: client.phone,
            contractValue: client.contractValue || '—',
            paymentTerms: client.paymentTerms || 'Standard',
            assignedManager: client.assignedManager || 'Unassigned',
            status: client.status,
            website: client.website || ''
        });
        setMgrShowEditModal(true);
    };

    const mgrSaveEdit = () => {
        if (!mgrSelectedClient) return;
        const updated = clients.map(c => {
            if (c.id === mgrSelectedClient.id) {
                return {
                    ...c,
                    company: mgrEditForm.company,
                    contactPerson: mgrEditForm.contactPerson,
                    email: mgrEditForm.email,
                    phone: mgrEditForm.phone,
                    contractValue: mgrEditForm.contractValue,
                    paymentTerms: mgrEditForm.paymentTerms,
                    assignedManager: mgrEditForm.assignedManager,
                    status: mgrEditForm.status,
                    website: mgrEditForm.website
                };
            }
            return c;
        });
        setClients(updated);
        localStorage.setItem('clientsData', JSON.stringify(updated));
        setMgrShowEditModal(false);
        alert(`✅ Client ${mgrEditForm.company} updated successfully!`);
    };

    const mgrHandleApprove = (client) => {
        setMgrSelectedClient(client);
        setMgrApprovalRemark('');
        setMgrShowApproveModal(true);
    };

    const mgrSubmitApproval = () => {
        if (!mgrSelectedClient) return;
        const updated = clients.map(c => {
            if (c.id === mgrSelectedClient.id) {
                return {
                    ...c,
                    status: 'Active',
                    approvalRemark: mgrApprovalRemark || 'Approved by Manager',
                    approvalDate: new Date().toISOString().split('T')[0]
                };
            }
            return c;
        });
        setClients(updated);
        localStorage.setItem('clientsData', JSON.stringify(updated));
        setMgrShowApproveModal(false);
        alert(`✅ Client ${mgrSelectedClient.company} has been approved.`);
    };

    const mgrSendReminder = (client) => {
        alert(`📧 Renewal reminder sent to ${client.email} for contract ending on ${mgrFormatDate(client.toDate)}`);
    };

    // Filter clients based on search
    const filteredClients = clients.filter(client =>
        client.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.contactPerson.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientNo.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div style={containerStyle}>
            {/* Header */}
            <div style={headerStyle}>
                <div style={headerLeftStyle}>
                    <div style={headerIconStyle}>
                        <FaUsers size={22} />
                    </div>
                    <div>
                        <h2 style={titleStyle}>Manager Clients</h2>
                        <p style={subtitleStyle}>Manage and oversee all client accounts</p>
                    </div>
                </div>
            </div>

            {/* Stats Cards */}
            <div style={statsContainerStyle}>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
                        <FaUsers style={{ color: '#4F46E5' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{totalClients}</div>
                        <div style={statLabelStyle}>Total Clients</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
                        <FaCheckCircle style={{ color: '#059669' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{activeClients}</div>
                        <div style={statLabelStyle}>Active</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FEF3C7' }}>
                        <FaClock style={{ color: '#D97706' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{renewalsPending}</div>
                        <div style={statLabelStyle}>Renewals Due</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#DBEAFE' }}>
                        <FaFilePdf style={{ color: '#1E40AF' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{poGeneratedCount}</div>
                        <div style={statLabelStyle}>PO Generated</div>
                    </div>
                </div>
            </div>

            {/* Search */}
            <div style={searchFilterContainerStyle}>
                <div style={searchContainerStyle}>
                    <FaSearch style={searchIconStyle} />
                    <input
                        type="text"
                        placeholder="Search by company, contact, email, client ID..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={searchInputStyle}
                    />
                    {searchTerm && (
                        <button onClick={() => setSearchTerm('')} style={clearSearchButtonStyle}>
                            <FaTimes size={14} />
                        </button>
                    )}
                </div>
                <div style={resultCountStyle}>
                    {filteredClients.length} result{filteredClients.length !== 1 && 's'}
                </div>
            </div>

            {/* Table */}
            <div style={tableCardStyle}>
                {loading ? (
                    <div style={loadingStyle}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
                        <p>Loading clients...</p>
                    </div>
                ) : (
                    <div style={tableWrapperStyle}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={{ ...thStyle, width: '5%', textAlign: 'center' }}>#</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Client #</th>
                                    <th style={{ ...thStyle, width: '12%', textAlign: 'left' }}>Company</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'left' }}>Contact</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Value</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Valid Till</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>PO Status</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Status</th>
                                    <th style={{ ...thStyle, width: '25%', textAlign: 'center' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredClients.length === 0 ? (
                                    <tr>
                                        <td colSpan="9" style={emptyStateStyle}>
                                            <div style={emptyStateContentStyle}>
                                                <FaUsers size={40} color="#D1D5DB" />
                                                <p>No clients found</p>
                                                <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                                                    {searchTerm ? 'Try adjusting your search terms' : 'No clients available'}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredClients.map((client, index) => (
                                        <tr key={client.id} style={{ ...tableRowStyle, background: mgrIsRenewalNeeded(client.toDate) ? '#FEF3C7' : 'transparent' }}>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
                                                {index + 1}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#4F46E5', fontSize: '12px' }}>
                                                {client.clientNo}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'left', fontWeight: 500 }}>
                                                {client.company}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'left' }}>
                                                {client.contactPerson}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
                                                {client.contractValue || '—'}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px' }}>
                                                {mgrFormatDate(client.toDate)}
                                                {mgrIsRenewalNeeded(client.toDate) && (
                                                    <span style={{ marginLeft: '4px', fontSize: '14px' }}>⚠️</span>
                                                )}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                {client.poGenerated ? (
                                                    <span style={{ ...badgeStyle, background: '#D1FAE5', color: '#059669' }}>
                                                        ✅ {client.lastPONumber}
                                                    </span>
                                                ) : (
                                                    <span style={{ ...badgeStyle, background: '#FEF3C7', color: '#D97706' }}>
                                                        Pending
                                                    </span>
                                                )}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={{
                                                    ...badgeStyle,
                                                    background: client.status === 'Active' ? '#D1FAE5' : '#FEE2E2',
                                                    color: client.status === 'Active' ? '#059669' : '#DC2626'
                                                }}>
                                                    {client.status}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <div style={actionGroupStyle}>
                                                    <button
                                                        style={viewButtonStyle}
                                                        onClick={() => mgrHandleView(client)}
                                                        title="View Details"
                                                    >
                                                        <FaEye size={13} />
                                                    </button>
                                                    <button
                                                        style={editButtonStyle}
                                                        onClick={() => mgrHandleEdit(client)}
                                                        title="Edit"
                                                    >
                                                        <FaEdit size={13} />
                                                    </button>
                                                    {client.status !== 'Active' && (
                                                        <button
                                                            style={approveButtonStyle}
                                                            onClick={() => mgrHandleApprove(client)}
                                                            title="Approve"
                                                        >
                                                            <FaCheck size={13} />
                                                        </button>
                                                    )}
                                                    <button
                                                        style={reminderButtonStyle}
                                                        onClick={() => mgrSendReminder(client)}
                                                        title="Send Reminder"
                                                    >
                                                        <FaPaperPlane size={13} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* ========== VIEW CLIENT MODAL ========== */}
            {mgrShowViewModal && mgrSelectedClient && (
                <div style={modalOverlayStyle} onClick={() => setMgrShowViewModal(false)}>
                    <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={modalHeaderIconStyle}>
                                    <FaEye size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Client Details - {mgrSelectedClient.clientNo}</h3>
                            </div>
                            <button onClick={() => setMgrShowViewModal(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Company Information</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Company:</strong> {mgrSelectedClient.company}</div>
                                    <div><strong>Client #:</strong> {mgrSelectedClient.clientNo}</div>
                                    <div><strong>Website:</strong> {mgrSelectedClient.website || '—'}</div>
                                    <div><strong>Source:</strong> {mgrSelectedClient.source}</div>
                                </div>
                            </div>

                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Contact Information</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Contact Person:</strong> {mgrSelectedClient.contactPerson}</div>
                                    <div><strong>Email:</strong> {mgrSelectedClient.email}</div>
                                    <div><strong>Phone:</strong> {mgrSelectedClient.phone}</div>
                                    <div><strong>Linked Enquiry:</strong> {mgrSelectedClient.linkedEnquiry || '—'}</div>
                                </div>
                            </div>

                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Contract Details</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Valid From:</strong> {mgrFormatDate(mgrSelectedClient.fromDate)}</div>
                                    <div><strong>Valid To:</strong> {mgrFormatDate(mgrSelectedClient.toDate)}</div>
                                    <div><strong>Contract Value:</strong> <span style={{ fontWeight: 700, color: '#059669' }}>{mgrSelectedClient.contractValue || '—'}</span></div>
                                    <div><strong>Payment Terms:</strong> {mgrSelectedClient.paymentTerms || '—'}</div>
                                    <div><strong>Next Renewal:</strong> {mgrFormatDate(mgrSelectedClient.nextRenewalDate)}</div>
                                    <div><strong>PO Status:</strong> {mgrSelectedClient.poGenerated ? `✅ ${mgrSelectedClient.lastPONumber}` : 'Pending'}</div>
                                </div>
                            </div>

                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Assignment</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Assigned Manager:</strong> {mgrSelectedClient.assignedManager}</div>
                                    <div><strong>Owner:</strong> {mgrSelectedClient.owner}</div>
                                    <div><strong>Status:</strong> <span style={{ ...badgeStyle, background: mgrSelectedClient.status === 'Active' ? '#D1FAE5' : '#FEE2E2', color: mgrSelectedClient.status === 'Active' ? '#059669' : '#DC2626' }}>{mgrSelectedClient.status}</span></div>
                                </div>
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={() => setMgrShowViewModal(false)}
                                style={cancelButtonStyle}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ========== EDIT CLIENT MODAL ========== */}
            {mgrShowEditModal && mgrSelectedClient && (
                <div style={modalOverlayStyle} onClick={() => setMgrShowEditModal(false)}>
                    <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={modalHeaderIconStyle}>
                                    <FaEdit size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Edit Client - {mgrSelectedClient.company}</h3>
                            </div>
                            <button onClick={() => setMgrShowEditModal(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Company Name <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    type="text"
                                    value={mgrEditForm.company}
                                    onChange={(e) => setMgrEditForm({ ...mgrEditForm, company: e.target.value })}
                                    style={inputStyle}
                                />
                            </div>

                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Contact Person</label>
                                    <input
                                        type="text"
                                        value={mgrEditForm.contactPerson}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, contactPerson: e.target.value })}
                                        style={inputStyle}
                                    />
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Email</label>
                                    <input
                                        type="email"
                                        value={mgrEditForm.email}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, email: e.target.value })}
                                        style={inputStyle}
                                    />
                                </div>
                            </div>

                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Phone</label>
                                    <input
                                        type="text"
                                        value={mgrEditForm.phone}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, phone: e.target.value })}
                                        style={inputStyle}
                                    />
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Website</label>
                                    <input
                                        type="text"
                                        value={mgrEditForm.website}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, website: e.target.value })}
                                        style={inputStyle}
                                    />
                                </div>
                            </div>

                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Contract Value</label>
                                    <input
                                        type="text"
                                        value={mgrEditForm.contractValue}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, contractValue: e.target.value })}
                                        placeholder="₹XX,XX,XXX"
                                        style={inputStyle}
                                    />
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Payment Terms</label>
                                    <select
                                        value={mgrEditForm.paymentTerms}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, paymentTerms: e.target.value })}
                                        style={selectStyle}
                                    >
                                        {mgrPaymentTermsOptions.map(opt => (
                                            <option key={opt} value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Assigned Manager</label>
                                    <select
                                        value={mgrEditForm.assignedManager}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, assignedManager: e.target.value })}
                                        style={selectStyle}
                                    >
                                        {mgrManagerOptions.map(opt => (
                                            <option key={opt} value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Status</label>
                                    <select
                                        value={mgrEditForm.status}
                                        onChange={(e) => setMgrEditForm({ ...mgrEditForm, status: e.target.value })}
                                        style={selectStyle}
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Pending Approval">Pending Approval</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={() => setMgrShowEditModal(false)}
                                style={cancelButtonStyle}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={mgrSaveEdit}
                                style={saveButtonStyle}
                            >
                                <FaCheck size={14} /> Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ========== APPROVE CLIENT MODAL ========== */}
            {mgrShowApproveModal && mgrSelectedClient && (
                <div style={modalOverlayStyle} onClick={() => setMgrShowApproveModal(false)}>
                    <div style={{ ...modalStyle, maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #10B981, #059669)' }}>
                                    <FaCheck size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Approve Client Contract</h3>
                            </div>
                            <button onClick={() => setMgrShowApproveModal(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={approvalInfoStyle}>
                                <div><strong>Client:</strong> {mgrSelectedClient.company}</div>
                                <div><strong>Status:</strong> {mgrSelectedClient.status}</div>
                                <div><strong>Contract:</strong> {mgrFormatDate(mgrSelectedClient.fromDate)} → {mgrFormatDate(mgrSelectedClient.toDate)}</div>
                            </div>

                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Approval Remarks (Optional)</label>
                                <textarea
                                    rows="3"
                                    placeholder="Add any notes or conditions..."
                                    value={mgrApprovalRemark}
                                    onChange={(e) => setMgrApprovalRemark(e.target.value)}
                                    style={textareaStyle}
                                />
                            </div>

                            <div style={warningNoteStyle}>
                                ⚡ Approving this client will mark the contract as "Active" and enable all features.
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={() => setMgrShowApproveModal(false)}
                                style={cancelButtonStyle}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={mgrSubmitApproval}
                                style={approveSubmitButtonStyle}
                            >
                                <FaCheck size={14} /> Confirm Approval
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

// ─── Styles ──────────────────────────────────────────────────────

const containerStyle = {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
};

const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
    flexWrap: 'wrap',
    gap: '16px',
};

const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
};

const headerIconStyle = {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const titleStyle = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#111827',
    margin: 0,
    letterSpacing: '-0.5px',
};

const subtitleStyle = {
    fontSize: '14px',
    color: '#6B7280',
    margin: '4px 0 0 0',
};

// Stats Styles
const statsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
    marginBottom: '10px',
};

const statCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    background: '#fff',
    padding: '18px 20px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    border: '1px solid #E5E7EB',
    transition: 'all 0.2s ease',
};

const statIconWrapperStyle = {
    width: '44px',
    height: '44px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const statNumberStyle = {
    fontSize: '22px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2,
};

const statLabelStyle = {
    fontSize: '13px',
    color: '#6B7280',
    fontWeight: 500,
};

// Search Styles
const searchFilterContainerStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '10px',
    flexWrap: 'wrap',
    alignItems: 'center',
};

const searchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: '200px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 16px',
    transition: 'all 0.2s ease',
};

const searchIconStyle = {
    color: '#9CA3AF',
    marginRight: '12px',
};

const searchInputStyle = {
    flex: 1,
    padding: '11px 0',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    color: '#111827',
};

const clearSearchButtonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#9CA3AF',
    padding: '4px 8px',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
};

const resultCountStyle = {
    fontSize: '13px',
    color: '#6B7280',
    fontWeight: 500,
};

// Table Styles
const tableCardStyle = {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    border: '1px solid #E5E7EB',
};

const tableWrapperStyle = {
    overflowX: 'auto',
    padding: '0',
    maxHeight: 'calc(100vh - 450px)',
    overflowY: 'auto',
    scrollbarWidth:"thin",
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1100px',
};

const thStyle = {
    padding: '12px 16px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#6B7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    background: '#F9FAFB',
    borderBottom: '1px solid #E5E7EB',
    position: 'sticky',
    top: 0,
    zIndex: 10,
};

const tdStyle = {
    padding: '12px 16px',
    fontSize: '13px',
    color: '#111827',
    borderBottom: '1px solid #F3F4F6',
};

const tableRowStyle = {
    transition: 'background 0.15s ease',
    cursor: 'default',
};

const badgeStyle = {
    display: 'inline-block',
    padding: '3px 12px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
};

// Action Buttons
const actionGroupStyle = {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    flexWrap: 'wrap',
};

const viewButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    background: '#60A5FA',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const editButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    background: '#34D399',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const approveButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    background: '#10B981',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const reminderButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    background: '#8B5CF6',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

// Empty State
const emptyStateStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    borderBottom: 'none',
};

const emptyStateContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
};

const loadingStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#6B7280',
};

// Modal Styles
const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: 'fadeIn 0.25s ease',
};

const modalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '720px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
    animation: 'slideUp 0.3s ease',
};

const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 1,
};

const modalHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
};

const modalHeaderIconStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const modalTitleStyle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const modalCloseStyle = {
    background: '#F3F4F6',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '6px 10px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
};

const modalBodyStyle = {
    padding: '24px',
};

// View Styles
const viewSectionStyle = {
    border: '1px solid #F3F4F6',
    borderRadius: '8px',
    padding: '14px 16px',
    marginBottom: '12px',
};

const viewSectionTitleStyle = {
    margin: '0 0 10px 0',
    fontSize: '14px',
    fontWeight: 600,
    color: '#1E293B',
};

const viewGridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px 16px',
};

// Form Styles
const formRowStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '14px',
    marginBottom: '14px',
};

const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    marginBottom: '14px',
};

const labelStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
};

const inputStyle = {
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease',
    background: '#fff',
    color: '#111827',
};

const selectStyle = {
    ...inputStyle,
    appearance: 'auto',
};

const textareaStyle = {
    ...inputStyle,
    resize: 'vertical',
    fontFamily: 'inherit',
    width: '100%',
};

const formActionStyle = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '8px',
    paddingTop: '16px',
    borderTop: '1px solid #F3F4F6',
};

const cancelButtonStyle = {
    padding: '10px 24px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const saveButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #e66d33, #d45a2a)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(230, 109, 51, 0.3)',
};

const approveSubmitButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #10B981, #059669)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
};

// Approval Info
const approvalInfoStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '12px',
    padding: '12px 16px',
    background: '#F9FAFB',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #E5E7EB',
};

const warningNoteStyle = {
    padding: '12px 16px',
    background: '#FEF3C7',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#92400E',
    border: '1px solid #FDE68A',
};

export default ManagerClients;